module.exports = __webpack_public_path__ + "img/rabbit_helpers_logo_word.824028cc.png";